// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { provisionOrganization, provisionSite } from '../../helios/services/provisioningService';
import type {
  ProvisionOrganizationRequest,
  ProvisionSiteRequest,
  ProvisioningRun,
} from '../../helios/services/provisioningService';

/**
 * Starts `OrganizationCreation_v0`. Invalidates the org list so the new
 * organization appears once the run assigns its id.
 */
export function useProvisionOrganization() {
  const qc = useQueryClient();
  return useMutation<ProvisioningRun, Error, ProvisionOrganizationRequest>({
    mutationFn: provisionOrganization,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['provisioning', 'organizations'] }),
  });
}

/** Starts `SiteCreation_v0` for one organization. */
export function useProvisionSite(orgId: string | undefined) {
  const qc = useQueryClient();
  return useMutation<ProvisioningRun, Error, ProvisionSiteRequest>({
    mutationFn: provisionSite,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['provisioning', 'sites', orgId] }),
  });
}
